export const VISITOR_REGISTRATION = 'VISITOR_REGISTRATION';
